/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetPluginAssignmentsForm,
  SetPluginAssignmentsForm$Outbound,
  SetPluginAssignmentsForm$outboundSchema,
} from "../components/setpluginassignmentsform.js";

export type SetPluginAssignmentsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetPluginAssignmentsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setPluginAssignmentsForm: SetPluginAssignmentsForm;
};

/** @internal */
export type SetPluginAssignmentsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetPluginAssignmentsSecurity$outboundSchema: z.ZodMiniType<
  SetPluginAssignmentsSecurity$Outbound,
  SetPluginAssignmentsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setPluginAssignmentsSecurityToJSON(
  setPluginAssignmentsSecurity: SetPluginAssignmentsSecurity,
): string {
  return JSON.stringify(
    SetPluginAssignmentsSecurity$outboundSchema.parse(
      setPluginAssignmentsSecurity,
    ),
  );
}

/** @internal */
export type SetPluginAssignmentsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetPluginAssignmentsForm: SetPluginAssignmentsForm$Outbound;
};

/** @internal */
export const SetPluginAssignmentsRequest$outboundSchema: z.ZodMiniType<
  SetPluginAssignmentsRequest$Outbound,
  SetPluginAssignmentsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setPluginAssignmentsForm: SetPluginAssignmentsForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      setPluginAssignmentsForm: "SetPluginAssignmentsForm",
    });
  }),
);

export function setPluginAssignmentsRequestToJSON(
  setPluginAssignmentsRequest: SetPluginAssignmentsRequest,
): string {
  return JSON.stringify(
    SetPluginAssignmentsRequest$outboundSchema.parse(
      setPluginAssignmentsRequest,
    ),
  );
}
